var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWantou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.88566 0.823528L1.88566 0.5H8.33332V0.823529V4.76471C8.33332 5.59313 9.0049 6.26471 9.83332 6.26471H14.6667H15V12.6765H14.6667H7.38567C4.34811 12.6765 1.88567 10.214 1.88567 7.17647L1.88567 6.11936L1.88566 0.823528Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWantou);
export default __webpack_public_path__ + "static/media/wantou.f8b9a39313445107e12e95c86cc89656.svg";
export { ForwardRef as ReactComponent };